export enum PLATFORM_SOURCE {
  FD = "fd",
  DR = "dr",
}

export enum USER_PERSONA {
  STAFF = "staff",
  DOC = "doc",
}

export enum SDK_PLATFORM {
  PATIENT = "patient",
  DOCTOR = "doctor",
}

export enum SDK_REGION {
  INDIA = "in",
  USA = "us",
}

export enum LANGUAGE_KEY {
  ENGLISH = "en",
  HINDI = "hi",
  TAMIL = "ta",
  TELGU = "te",
  MARATHI = "mr",
  GUJRATI = "gu",
  MALAYALAM = "ml",
  BANGALI = "bn",
  ASSAMESE = "as",
  KANNADA = "kn",
}

export enum CLIENT_ID {
  ANDROIDP = "androidp",
  DOCWEB = "doc-web",
}
